import { NextPage } from 'next'
import OneClickPayScreen from '../screens/OneClickPay'

export const OneClickPay: NextPage = () => {

    return (
        <>
            <OneClickPayScreen />
        </>
    )
}
